export default {
  methods: {
    handleBackHome() {
      this.$router.replace({
        path: '/'
      });
    }
  }
};